import { render, staticRenderFns } from "./assetView.vue?vue&type=template&id=b90b2092&scoped=true"
import script from "./assetView.vue?vue&type=script&lang=js"
export * from "./assetView.vue?vue&type=script&lang=js"
import style0 from "./assetView.vue?vue&type=style&index=0&id=b90b2092&prod&lang=scss&scoped=true"
import style1 from "./assetView.vue?vue&type=style&index=1&id=b90b2092&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90b2092",
  null
  
)

export default component.exports